var items = {
  "block.minecraft.air": "afẹfẹ",
  "block.minecraft.stone": "okuta",
  "block.minecraft.granite": "giranaiti",
  "block.minecraft.polished_granite": "pólándì giranaiti",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "pólándì diorite",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "pólándì andesite",
  "block.minecraft.grass_block": "dii koriko",
  "block.minecraft.dirt": "aiye",
  "block.minecraft.coarse_dirt": "aye lile",
  "block.minecraft.podzol": "alaadun",
  "block.minecraft.crimson_nylium": "pupa nylium",
  "block.minecraft.warped_nylium": "nylium ti ogun",
  "block.minecraft.cobblestone": "pèpéle",
  "block.minecraft.oak_planks": "igi oaku",
  "block.minecraft.spruce_planks": "ọkọ abẹrẹ",
  "block.minecraft.birch_planks": "ile-iṣẹ birch",
  "block.minecraft.jungle_planks": "ile-iṣẹ igbo",
  "block.minecraft.acacia_planks": "apẹrẹ acacia",
  "block.minecraft.dark_oak_planks": "obo igi oaku dudu",
  "block.minecraft.crimson_planks": "crimson planks",
  "block.minecraft.warped_planks": "planks planed",
  "block.minecraft.oak_sapling": "ororoo oaku",
  "block.minecraft.spruce_sapling": "ororoo dara",
  "block.minecraft.birch_sapling": "ororoo birch",
  "block.minecraft.jungle_sapling": "ororoo igboro",
  "block.minecraft.acacia_sapling": "ororoo igbá",
  "block.minecraft.dark_oak_sapling": "ororoo oaku dudu",
  "block.minecraft.bedrock": "lya apata",
  "block.minecraft.sand": "iyanrin",
  "block.minecraft.red_sand": "iyanrin pupa",
  "block.minecraft.gravel": "wẹwẹ",
  "block.minecraft.gold_ore": "ohun irin goolu",
  "block.minecraft.iron_ore": "iron ẹsọ́",
  "block.minecraft.coal_ore": "erogba irin",
  "block.minecraft.nether_gold_ore": "nether ore gold",
  "block.minecraft.oak_log": "oka wọle",
  "block.minecraft.spruce_log": "spruce wọle",
  "block.minecraft.birch_log": "birch wọle",
  "block.minecraft.jungle_log": "jungle wọle",
  "block.minecraft.acacia_log": "acacia wọle",
  "block.minecraft.dark_oak_log": "oaku wọle ojiji",
  "block.minecraft.crimson_stem": "crimson stalk",
  "block.minecraft.warped_stem": "igbiyanju",
  "block.minecraft.stripped_oak_log": "ti pa oka wọle",
  "block.minecraft.stripped_spruce_log": "ti pa spruce wọle",
  "block.minecraft.stripped_birch_log": "ti pa spruce wọle",
  "block.minecraft.stripped_jungle_log": "ti pa spruce wọle",
  "block.minecraft.stripped_acacia_log": "pa acacia wọle",
  "block.minecraft.stripped_dark_oak_log": "wọle oaku wọle ti dudu",
  "block.minecraft.stripped_crimson_stem": "kọlu crimson stem",
  "block.minecraft.stripped_warped_stem": "igbese steped ti a ni nkan",
  "block.minecraft.stripped_oak_wood": "igi oaku ti a gbin",
  "block.minecraft.stripped_spruce_wood": "igi igi ti a lu",
  "block.minecraft.stripped_birch_wood": "igi birch ti a lu",
  "block.minecraft.stripped_jungle_wood": "igi igi ti a gbin",
  "block.minecraft.stripped_acacia_wood": "igi acacia ti gbin",
  "block.minecraft.stripped_dark_oak_wood": "wọle oaku wọle ti dudu",
  "block.minecraft.stripped_crimson_hyphae": "kọlu crimson hyphae",
  "block.minecraft.stripped_warped_hyphae": "kọlu hyphae ti bajẹ",
  "block.minecraft.oak_wood": "oaku igi",
  "block.minecraft.spruce_wood": "spruce igi",
  "block.minecraft.birch_wood": "birch igi",
  "block.minecraft.jungle_wood": "jungle igi",
  "block.minecraft.acacia_wood": "acacia igi",
  "block.minecraft.dark_oak_wood": "oaku dudu igi",
  "block.minecraft.crimson_hyphae": "crimson hyphae",
  "block.minecraft.warped_hyphae": "hyphae ti ogun",
  "block.minecraft.oak_leaves": "oaku bunkun",
  "block.minecraft.spruce_leaves": "spruce bunkun",
  "block.minecraft.birch_leaves": "birch bunkun",
  "block.minecraft.jungle_leaves": "jungle bunkun",
  "block.minecraft.acacia_leaves": "acacia bunkun",
  "block.minecraft.dark_oak_leaves": "oaku dudu bunkun",
  "block.minecraft.sponge": "kanrinkan",
  "block.minecraft.wet_sponge": "tutu kanrinkan",
  "block.minecraft.glass": "gilasi",
  "block.minecraft.lapis_ore": "lapis lazuli ẹsọ́",
  "block.minecraft.lapis_block": "lapis lazuli àkọsílẹ",
  "block.minecraft.dispenser": "atokan",
  "block.minecraft.sandstone": "iyanrinokuta",
  "block.minecraft.chiseled_sandstone": "gbe iyanrinokuta",
  "block.minecraft.cut_sandstone": "ge gusu",
  "block.minecraft.note_block": "àkọsílẹ dun",
  "block.minecraft.powered_rail": "agbara iṣinipopada",
  "block.minecraft.detector_rail": "iṣinipopada pẹlu sensọ",
  "block.minecraft.sticky_piston": "piston alalepo",
  "block.minecraft.cobweb": "ibuwọlu",
  "block.minecraft.grass": "koriko",
  "block.minecraft.fern": "ewedò wẹ̀wẹ̀",
  "block.minecraft.dead_bush": "igi ti o gbẹ",
  "block.minecraft.seagrass": "seagrass",
  "block.minecraft.sea_pickle": "pupa pickle",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "funfun kìki irun",
  "block.minecraft.orange_wool": "osan kìki irun",
  "block.minecraft.magenta_wool": "crimson kìki irun",
  "block.minecraft.light_blue_wool": "imọlẹ bulu kìki irun",
  "block.minecraft.yellow_wool": "iyeye kìki irun",
  "block.minecraft.lime_wool": "imọlẹ kìki irun",
  "block.minecraft.pink_wool": "òdòdó kìki irun",
  "block.minecraft.gray_wool": "grẹy kìki irun",
  "block.minecraft.light_gray_wool": "imọlẹ grẹy kìki irun",
  "block.minecraft.cyan_wool": "samawati kìki irun",
  "block.minecraft.purple_wool": "àluko kìki irun",
  "block.minecraft.blue_wool": "bulu kìki irun",
  "block.minecraft.brown_wool": "orukọ kìki irun",
  "block.minecraft.green_wool": "aipọn kìki irun",
  "block.minecraft.red_wool": "pupa kìki irun",
  "block.minecraft.black_wool": "dudu kìki irun",
  "block.minecraft.dandelion": "gbìn",
  "block.minecraft.poppy": "irugbin",
  "block.minecraft.blue_orchid": "bulu orchid",
  "block.minecraft.allium": "ata",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "pupa tulip",
  "block.minecraft.orange_tulip": "osan tulip",
  "block.minecraft.white_tulip": "funfun tulip",
  "block.minecraft.pink_tulip": "òdòdó tulip",
  "block.minecraft.oxeye_daisy": "aṣiṣe",
  "block.minecraft.cornflower": "oka",
  "block.minecraft.lily_of_the_valley": "lily ti afonifoji",
  "block.minecraft.wither_rose": "wither soke",
  "block.minecraft.brown_mushroom": "brown olu",
  "block.minecraft.red_mushroom": "olu pupa",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "dari fungus",
  "block.minecraft.crimson_roots": "oloogun roots",
  "block.minecraft.warped_roots": "ogun roots",
  "block.minecraft.nether_sprouts": "awọn sprouts netherlands",
  "block.minecraft.weeping_vines": "ẹkun ajara",
  "block.minecraft.twisting_vines": "fọn igi àjara",
  "block.minecraft.sugar_cane": "ohun ọgbin",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "oparun",
  "block.minecraft.gold_block": "iwọn goolu",
  "block.minecraft.iron_block": "iwọn iron",
  "block.minecraft.oak_slab": "oaku awo",
  "block.minecraft.spruce_slab": "egungun spruce",
  "block.minecraft.birch_slab": "birch awo",
  "block.minecraft.jungle_slab": "ipele igbo",
  "block.minecraft.acacia_slab": "akara awo",
  "block.minecraft.dark_oak_slab": "oaku ti oṣu dudu",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "slab ogun",
  "block.minecraft.stone_slab": "okuta awo",
  "block.minecraft.smooth_stone_slab": "awọn ikọpọ ọgbọn ẹwa",
  "block.minecraft.sandstone_slab": "apẹrẹ gusu",
  "block.minecraft.cut_sandstone_slab": "ge igi iku-okuta",
  "block.minecraft.petrified_oak_slab": "oaku igi oaku ti o ti gbilẹ",
  "block.minecraft.cobblestone_slab": "pèpéle gba",
  "block.minecraft.brick_slab": "brick awo",
  "block.minecraft.stone_brick_slab": "brick awo okuta",
  "block.minecraft.nether_brick_slab": "nether biriki gbu",
  "block.minecraft.quartz_slab": "kuotisi gbu",
  "block.minecraft.red_sandstone_slab": "pupa apẹrẹ gusu",
  "block.minecraft.cut_red_sandstone_slab": "ge okun iyan-pupa",
  "block.minecraft.purpur_slab": "elese pẹlẹbẹ",
  "block.minecraft.prismarine_slab": "plate pẹlu prismarine",
  "block.minecraft.prismarine_brick_slab": "brick awo pẹlu prismarine",
  "block.minecraft.dark_prismarine_slab": "akara dudu pẹlu prismarine kan",
  "block.minecraft.smooth_quartz": "dẹkun quartz dẹkun",
  "block.minecraft.smooth_red_sandstone": "dudu pupa gusu",
  "block.minecraft.smooth_sandstone": "dudu gusu",
  "block.minecraft.smooth_stone": "dudu okuta",
  "block.minecraft.bricks": "biriki",
  "block.minecraft.tnt": "ìmúdàgba",
  "block.minecraft.bookshelf": "iwe oju",
  "block.minecraft.mossy_cobblestone": "a apẹrẹ paati",
  "block.minecraft.obsidian": "ojuju",
  "block.minecraft.torch": "ògùṣọ",
  "block.minecraft.end_rod": "oṣiṣẹ ipari",
  "block.minecraft.chorus_plant": "ọkọ ikọja",
  "block.minecraft.chorus_flower": "egbe flower",
  "block.minecraft.purpur_block": "purpur block",
  "block.minecraft.purpur_pillar": "purpur pillar",
  "block.minecraft.purpur_stairs": "awọn pẹtẹẹsẹ purpur",
  "block.minecraft.spawner": "ti o dara",
  "block.minecraft.oak_stairs": "pẹtẹẹsì oke",
  "block.minecraft.chest": "àyà",
  "block.minecraft.diamond_ore": "okuta ẹsọ́",
  "block.minecraft.diamond_block": "àkọsílẹ okuta",
  "block.minecraft.crafting_table": "ipele iṣẹ",
  "block.minecraft.farmland": "aaye ti a gbin",
  "block.minecraft.furnace": "beki",
  "block.minecraft.ladder": "akaba",
  "block.minecraft.rail": "iṣinipopada",
  "block.minecraft.cobblestone_stairs": "pèpéle atẹgun",
  "block.minecraft.lever": "lefa",
  "block.minecraft.stone_pressure_plate": "okuta atilẹyin itoju",
  "block.minecraft.oak_pressure_plate": "atilẹyin itoju oaku",
  "block.minecraft.spruce_pressure_plate": "iwọn spruce ipaju",
  "block.minecraft.birch_pressure_plate": "birch ipa titẹ",
  "block.minecraft.jungle_pressure_plate": "ikọju igi ilu",
  "block.minecraft.acacia_pressure_plate": "acacia ipaju awo",
  "block.minecraft.dark_oak_pressure_plate": "dudu oaku ipaba",
  "block.minecraft.crimson_pressure_plate": "plateson ipa plate",
  "block.minecraft.warped_pressure_plate": "plateau ipa ipa",
  "block.minecraft.polished_blackstone_pressure_plate": "awo didan stone ipa",
  "block.minecraft.redstone_ore": "redstone irin",
  "block.minecraft.redstone_torch": "redstone ògùṣọ",
  "block.minecraft.snow": "egbon",
  "block.minecraft.ice": "yinyin",
  "block.minecraft.snow_block": "isinmi apẹrẹ",
  "block.minecraft.cactus": "ọrọ",
  "block.minecraft.clay": "amo",
  "block.minecraft.jukebox": "aṣọ ti ndun",
  "block.minecraft.oak_fence": "oaku odi",
  "block.minecraft.spruce_fence": "spruce odi",
  "block.minecraft.birch_fence": "birch odi",
  "block.minecraft.jungle_fence": "jungle odi",
  "block.minecraft.acacia_fence": "acacia odi",
  "block.minecraft.dark_oak_fence": "dudu oaku odi",
  "block.minecraft.crimson_fence": "crimson odi",
  "block.minecraft.warped_fence": "ogun ti odi",
  "block.minecraft.pumpkin": "elegede",
  "block.minecraft.carved_pumpkin": "ti gbe elegede",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "iyanrin ti ọkàn",
  "block.minecraft.soul_soil": "ọkàn",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt didan",
  "block.minecraft.soul_torch": "ọkàn torch",
  "block.minecraft.glowstone": "imọlẹ okuta",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "oak oṣuwọn",
  "block.minecraft.spruce_trapdoor": "spruce oṣuwọn",
  "block.minecraft.birch_trapdoor": "birch niye",
  "block.minecraft.jungle_trapdoor": "jungle niyeon",
  "block.minecraft.acacia_trapdoor": "acacia niye",
  "block.minecraft.dark_oak_trapdoor": "oṣuwọn ti oṣu dudu",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "trapdoor ti ogun",
  "block.minecraft.infested_stone": "okuta ti a da",
  "block.minecraft.infested_cobblestone": "ti fi kún pèpéle",
  "block.minecraft.infested_stone_bricks": "biriki okuta ti a ti fi ẹ si",
  "block.minecraft.infested_mossy_stone_bricks": "biriki ti a fi okuta pa ti a da",
  "block.minecraft.infested_cracked_stone_bricks": "biriki okuta ti a ti fi okuta ṣubu",
  "block.minecraft.infested_chiseled_stone_bricks": "biriki okuta ti a fi oju ṣe",
  "block.minecraft.stone_bricks": "okuta biriki",
  "block.minecraft.mossy_stone_bricks": "a apẹrẹ okuta biriki",
  "block.minecraft.cracked_stone_bricks": "bricks stone bricks",
  "block.minecraft.chiseled_stone_bricks": "awọn bricks odi bọtini",
  "block.minecraft.brown_mushroom_block": "ilana mycelium",
  "block.minecraft.red_mushroom_block": "iwe-iṣiro pupa mycelium",
  "block.minecraft.mushroom_stem": "egbin je",
  "block.minecraft.iron_bars": "iron bars",
  "block.minecraft.chain": "chain",
  "block.minecraft.glass_pane": "gilasi",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "ajara",
  "block.minecraft.oak_fence_gate": "oaku ẹnubodè pada",
  "block.minecraft.spruce_fence_gate": "spruce ẹnubodè pada",
  "block.minecraft.birch_fence_gate": "birch ẹnubodè pada",
  "block.minecraft.jungle_fence_gate": "jungle ẹnubodè pada",
  "block.minecraft.acacia_fence_gate": "acacia ẹnubodè pada",
  "block.minecraft.dark_oak_fence_gate": "dudu oaku ẹnubodè pada",
  "block.minecraft.crimson_fence_gate": "crimson fence gate",
  "block.minecraft.warped_fence_gate": "ẹnu ọ̀nà fence",
  "block.minecraft.brick_stairs": "brick okuta",
  "block.minecraft.stone_brick_stairs": "okuta brick awọn atẹsẹ",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "lily paadi",
  "block.minecraft.nether_bricks": "nether biriki",
  "block.minecraft.cracked_nether_bricks": "awọn biriki tẹtẹ",
  "block.minecraft.chiseled_nether_bricks": "awọn biriki nether biriki",
  "block.minecraft.nether_brick_fence": "nether brick fence",
  "block.minecraft.nether_brick_stairs": "nether brick okuta",
  "block.minecraft.enchanting_table": "tọpeli tabili",
  "block.minecraft.end_portal_frame": "eto ilana end portal",
  "block.minecraft.end_stone": "opin okuta",
  "block.minecraft.end_stone_bricks": "ipari awọn biriki stone",
  "block.minecraft.dragon_egg": "dragon ẹyin",
  "block.minecraft.redstone_lamp": "redstone atupa",
  "block.minecraft.sandstone_stairs": "iyanrinokuta atẹgun",
  "block.minecraft.emerald_ore": "emerald ore",
  "block.minecraft.ender_chest": "ender ọpa",
  "block.minecraft.tripwire_hook": "tripwire ifikọti",
  "block.minecraft.emerald_block": "àkọsílẹ ti emerald",
  "block.minecraft.spruce_stairs": "gbe atẹgun spruce",
  "block.minecraft.birch_stairs": "birch atẹgun",
  "block.minecraft.jungle_stairs": "atẹgun igbo",
  "block.minecraft.crimson_stairs": "awọn atẹgun crimson",
  "block.minecraft.warped_stairs": "awọn pẹtẹẹsì ogun",
  "block.minecraft.command_block": "bọtini ipa",
  "block.minecraft.beacon": "beakoni",
  "block.minecraft.cobblestone_wall": "odi cobblestone",
  "block.minecraft.mossy_cobblestone_wall": "mossy cobblestone odi",
  "block.minecraft.brick_wall": "odi biriki",
  "block.minecraft.prismarine_wall": "ile prismarine",
  "block.minecraft.red_sandstone_wall": "odi pupa sandstone",
  "block.minecraft.mossy_stone_brick_wall": "mossy stone brick wall",
  "block.minecraft.granite_wall": "granite arabara",
  "block.minecraft.stone_brick_wall": "okuta brick stone",
  "block.minecraft.nether_brick_wall": "apaadi apadi",
  "block.minecraft.andesite_wall": "andesite wall",
  "block.minecraft.red_nether_brick_wall": "red nether brick wall",
  "block.minecraft.sandstone_wall": "odi sandstone",
  "block.minecraft.end_stone_brick_wall": "pari odi brick stone",
  "block.minecraft.diorite_wall": "diorite wall",
  "block.minecraft.blackstone_wall": "dudu odi dudu",
  "block.minecraft.polished_blackstone_wall": "odi okuta odi dudu",
  "block.minecraft.polished_blackstone_brick_wall": "odi okuta biriki dudu",
  "block.minecraft.stone_button": "bọtini okuta",
  "block.minecraft.oak_button": "bọtini oaku",
  "block.minecraft.spruce_button": "bọtini spruce",
  "block.minecraft.birch_button": "bọtini birch",
  "block.minecraft.jungle_button": "bọtini jungle",
  "block.minecraft.acacia_button": "bọtini acacia",
  "block.minecraft.dark_oak_button": "bọtini lati oaku dudu",
  "block.minecraft.crimson_button": "bọtini crimson",
  "block.minecraft.warped_button": "bọtini ogun",
  "block.minecraft.polished_blackstone_button": "bọtini okuta okuta dudu",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "bọtini ti a ti bajẹ pupọ",
  "block.minecraft.damaged_anvil": "ago ti a ti bajẹ",
  "block.minecraft.trapped_chest": "àyà pakute",
  "block.minecraft.light_weighted_pressure_plate": "iwọn pilasi oye",
  "block.minecraft.heavy_weighted_pressure_plate": "iwọn ipilẹ ti o ni irọra pípẹ",
  "block.minecraft.daylight_detector": "oluwari oju-ọjọ",
  "block.minecraft.redstone_block": "àkọsílẹ ti redstone",
  "block.minecraft.nether_quartz_ore": "nether quatz ore",
  "block.minecraft.hopper": "hopper",
  "block.minecraft.chiseled_quartz_block": "chiseled quatz block",
  "block.minecraft.quartz_block": "block of quartz",
  "block.minecraft.quartz_bricks": "awọn biriki quartz",
  "block.minecraft.quartz_pillar": "ẹrọ quartz",
  "block.minecraft.quartz_stairs": "quartet awọn atẹgun",
  "block.minecraft.activator_rail": "ibere iṣinipopada",
  "block.minecraft.dropper": "ọgbẹ",
  "block.minecraft.white_terracotta": "funfun teracota",
  "block.minecraft.orange_terracotta": "osan terakota",
  "block.minecraft.magenta_terracotta": "crimson terakota",
  "block.minecraft.light_blue_terracotta": "imọlẹ bulu terakota",
  "block.minecraft.yellow_terracotta": "iyeye terakota",
  "block.minecraft.lime_terracotta": "imọlẹ terakota",
  "block.minecraft.pink_terracotta": "òdòdó terakota",
  "block.minecraft.gray_terracotta": "grẹy terakota",
  "block.minecraft.light_gray_terracotta": "imọlẹ grẹy terakota",
  "block.minecraft.cyan_terracotta": "samawati terakota",
  "block.minecraft.purple_terracotta": "àluko terakota",
  "block.minecraft.blue_terracotta": "bulu terakota",
  "block.minecraft.brown_terracotta": "orukọ terakota",
  "block.minecraft.green_terracotta": "aipọn terakota",
  "block.minecraft.red_terracotta": "pupa terakota",
  "block.minecraft.black_terracotta": "dudu terakota",
  "block.minecraft.barrier": "idankan",
  "block.minecraft.iron_trapdoor": "gbigbọn irín",
  "block.minecraft.hay_block": "igi ti koriko",
  "block.minecraft.white_carpet": "funfun capeti",
  "block.minecraft.orange_carpet": "osan carpeti",
  "block.minecraft.magenta_carpet": "crimson carpeti",
  "block.minecraft.light_blue_carpet": "imọlẹ bulu carpeti",
  "block.minecraft.yellow_carpet": "iyeye carpeti",
  "block.minecraft.lime_carpet": "imọlẹ carpeti",
  "block.minecraft.pink_carpet": "òdòdó carpeti",
  "block.minecraft.gray_carpet": "grẹy carpeti",
  "block.minecraft.light_gray_carpet": "imọlẹ grẹy carpeti",
  "block.minecraft.cyan_carpet": "samawati carpeti",
  "block.minecraft.purple_carpet": "àluko carpeti",
  "block.minecraft.blue_carpet": "bulu carpeti",
  "block.minecraft.brown_carpet": "orukọ carpeti",
  "block.minecraft.green_carpet": "aipọn carpeti",
  "block.minecraft.red_carpet": "pupa carpeti",
  "block.minecraft.black_carpet": "dudu carpeti",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "àkọsílẹ edu",
  "block.minecraft.packed_ice": "iwapọ yinyin",
  "block.minecraft.acacia_stairs": "acacia atẹgun",
  "block.minecraft.dark_oak_stairs": "pẹtẹẹsì oaku dudu",
  "block.minecraft.slime_block": "iwọn ilana slime",
  "block.minecraft.grass_path": "ọna koriko",
  "block.minecraft.sunflower": "oorun-ododo",
  "block.minecraft.lilac": "lai",
  "block.minecraft.rose_bush": "abo igbo",
  "block.minecraft.peony": "peonia",
  "block.minecraft.tall_grass": "wọle si ọna",
  "block.minecraft.large_fern": "nla ewedò wẹ̀wẹ̀",
  "block.minecraft.white_stained_glass": "funfun gilasi",
  "block.minecraft.orange_stained_glass": "osan gilasi",
  "block.minecraft.magenta_stained_glass": "crimson gilasi",
  "block.minecraft.light_blue_stained_glass": "imọlẹ bulu gilasi",
  "block.minecraft.yellow_stained_glass": "iyeye gilasi",
  "block.minecraft.lime_stained_glass": "imọlẹ aipọn gilasi",
  "block.minecraft.pink_stained_glass": "òdòdó gilasi",
  "block.minecraft.gray_stained_glass": "grẹy gilasi",
  "block.minecraft.light_gray_stained_glass": "imọlẹ grẹy gilasi",
  "block.minecraft.cyan_stained_glass": "samawati gilasi",
  "block.minecraft.purple_stained_glass": "àluko gilasi",
  "block.minecraft.blue_stained_glass": "bulu gilasi",
  "block.minecraft.brown_stained_glass": "orukọ gilasi",
  "block.minecraft.green_stained_glass": "aipọn gilasi",
  "block.minecraft.red_stained_glass": "pupa gilasi",
  "block.minecraft.black_stained_glass": "dudu gilasi",
  "block.minecraft.white_stained_glass_pane": "funfun gilasi",
  "block.minecraft.orange_stained_glass_pane": "osan gilasi",
  "block.minecraft.magenta_stained_glass_pane": "àwo-pupayò gilasi",
  "block.minecraft.light_blue_stained_glass_pane": "imọlẹ bulu gilasi",
  "block.minecraft.yellow_stained_glass_pane": "iyeye gilasi",
  "block.minecraft.lime_stained_glass_pane": "imọlẹ aipọn gilasi",
  "block.minecraft.pink_stained_glass_pane": "òdòdó gilasi",
  "block.minecraft.gray_stained_glass_pane": "grẹy gilasi",
  "block.minecraft.light_gray_stained_glass_pane": "imọlẹ grẹy gilasi",
  "block.minecraft.cyan_stained_glass_pane": "samawati gilasi",
  "block.minecraft.purple_stained_glass_pane": "àluko gilasi",
  "block.minecraft.blue_stained_glass_pane": "bulu gilasi",
  "block.minecraft.brown_stained_glass_pane": "orukọ gilasi",
  "block.minecraft.green_stained_glass_pane": "aipọn gilasi",
  "block.minecraft.red_stained_glass_pane": "pupa gilasi",
  "block.minecraft.black_stained_glass_pane": "dudu gilasi",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "awọn ohun amorindun prismarine",
  "block.minecraft.dark_prismarine": "prismarine pudu",
  "block.minecraft.prismarine_stairs": "prismarine atẹgun",
  "block.minecraft.prismarine_brick_stairs": "prismarine brick atẹgun",
  "block.minecraft.dark_prismarine_stairs": "pẹtẹẹsì dudu",
  "block.minecraft.sea_lantern": "okun okun",
  "block.minecraft.red_sandstone": "pupa iyanrinokuta",
  "block.minecraft.chiseled_red_sandstone": "gba pupa iyanrinokuta",
  "block.minecraft.cut_red_sandstone": "ge igi ikan-pupa",
  "block.minecraft.red_sandstone_stairs": "pupa iyanrinokuta atẹgun",
  "block.minecraft.repeating_command_block": "tun ipa iṣẹ tun ṣe",
  "block.minecraft.chain_command_block": "ṣiṣẹ ipa ti kii",
  "block.minecraft.magma_block": "dẹkun magma",
  "block.minecraft.nether_wart_block": "dẹkun nether wart",
  "block.minecraft.warped_wart_block": "window dena wart",
  "block.minecraft.red_nether_bricks": "biriki nether pupa",
  "block.minecraft.bone_block": "bọnkun dena",
  "block.minecraft.structure_void": "ko si be",
  "block.minecraft.observer": "oluwoye",
  "block.minecraft.shulker_box": "apoti shulker",
  "block.minecraft.white_shulker_box": "apoti shulker funfun",
  "block.minecraft.orange_shulker_box": "apoti shulker orange",
  "block.minecraft.magenta_shulker_box": "apoti magenta shulker",
  "block.minecraft.light_blue_shulker_box": "apoti shulker light",
  "block.minecraft.yellow_shulker_box": "apoti shulker yellow",
  "block.minecraft.lime_shulker_box": "orombo wewe apoti",
  "block.minecraft.pink_shulker_box": "apoti shulker pink",
  "block.minecraft.gray_shulker_box": "apoti shulker grey",
  "block.minecraft.light_gray_shulker_box": "apoti imọlẹ grey shulker",
  "block.minecraft.cyan_shulker_box": "apoti cyan shulker",
  "block.minecraft.purple_shulker_box": "apoti shulker apo",
  "block.minecraft.blue_shulker_box": "apoti shulker bulu",
  "block.minecraft.brown_shulker_box": "apoti shulker brown",
  "block.minecraft.green_shulker_box": "apoti shulker green",
  "block.minecraft.red_shulker_box": "apoti shulker pupa",
  "block.minecraft.black_shulker_box": "apoti shulker dudu",
  "block.minecraft.white_glazed_terracotta": "funfun glazed terracotta",
  "block.minecraft.orange_glazed_terracotta": "osan glazed terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta glazed terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "light blue glazed terracotta",
  "block.minecraft.yellow_glazed_terracotta": "yellow glazed terracotta",
  "block.minecraft.lime_glazed_terracotta": "orombo wewe glazed terracotta",
  "block.minecraft.pink_glazed_terracotta": "pink glazed terracotta",
  "block.minecraft.gray_glazed_terracotta": "grey glazed terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "light grey glazed terracotta",
  "block.minecraft.cyan_glazed_terracotta": "cyan glazed terracotta",
  "block.minecraft.purple_glazed_terracotta": "eleyi ti glazed terracotta",
  "block.minecraft.blue_glazed_terracotta": "glazed terracotta",
  "block.minecraft.brown_glazed_terracotta": "terracotta brown",
  "block.minecraft.green_glazed_terracotta": "alawọ ewe glazed terracotta",
  "block.minecraft.red_glazed_terracotta": "red glazed terracotta",
  "block.minecraft.black_glazed_terracotta": "dudu glazed terracotta",
  "block.minecraft.white_concrete": "nkan funfun",
  "block.minecraft.orange_concrete": "orange nkan",
  "block.minecraft.magenta_concrete": "ohun-ọṣọ magenta",
  "block.minecraft.light_blue_concrete": "light bulu nkan",
  "block.minecraft.yellow_concrete": "ohun ọṣọ alawọ",
  "block.minecraft.lime_concrete": "orombo to konge",
  "block.minecraft.pink_concrete": "alawọ ewe pink",
  "block.minecraft.gray_concrete": "grey nja",
  "block.minecraft.light_gray_concrete": "imọlẹ grey light",
  "block.minecraft.cyan_concrete": "ohun-elo cyan",
  "block.minecraft.purple_concrete": "nkankan alamọ",
  "block.minecraft.blue_concrete": "imọlẹ buluu",
  "block.minecraft.brown_concrete": "ipara brown",
  "block.minecraft.green_concrete": "alawọ ewe alawọ ewe",
  "block.minecraft.red_concrete": "nkan pupa",
  "block.minecraft.black_concrete": "nkan dudu",
  "block.minecraft.white_concrete_powder": "funfun ṣoki ti funfun",
  "block.minecraft.orange_concrete_powder": "orange nipon lulú",
  "block.minecraft.magenta_concrete_powder": "magenta ṣoki lulú",
  "block.minecraft.light_blue_concrete_powder": "pulu lulú light bulu",
  "block.minecraft.yellow_concrete_powder": "ipara alawọ ofeefee",
  "block.minecraft.lime_concrete_powder": "orombo wewe lulú",
  "block.minecraft.pink_concrete_powder": "pupa fẹẹrẹ lulú",
  "block.minecraft.gray_concrete_powder": "grey nja lulú",
  "block.minecraft.light_gray_concrete_powder": "ina grẹy nja lulú",
  "block.minecraft.cyan_concrete_powder": "lulú cyan lulú",
  "block.minecraft.purple_concrete_powder": "pululu konge lulú",
  "block.minecraft.blue_concrete_powder": "ipara lulú",
  "block.minecraft.brown_concrete_powder": "ipara lulú",
  "block.minecraft.green_concrete_powder": "lulú nja alawọ",
  "block.minecraft.red_concrete_powder": "pupa ṣoki lulú",
  "block.minecraft.black_concrete_powder": "dudu lulú fẹẹrẹ",
  "block.minecraft.turtle_egg": "ijapa ẹyin",
  "block.minecraft.dead_tube_coral_block": "block ti coral tubular apo",
  "block.minecraft.dead_brain_coral_block": "ohun amorindun ti ọpọlọ ikun ti o ku",
  "block.minecraft.dead_bubble_coral_block": "block ti okú nyoju iyun",
  "block.minecraft.dead_fire_coral_block": "okun iku akanku iku",
  "block.minecraft.dead_horn_coral_block": "okun okùn igbẹ agbẹ",
  "block.minecraft.tube_coral_block": "akara ideri tube",
  "block.minecraft.brain_coral_block": "dii ti iyun coral",
  "block.minecraft.bubble_coral_block": "block ti coral nkuta",
  "block.minecraft.fire_coral_block": "igbẹ aṣọ ina",
  "block.minecraft.horn_coral_block": "ti nmu coral block",
  "block.minecraft.tube_coral": "coral tube",
  "block.minecraft.brain_coral": "coral brain",
  "block.minecraft.bubble_coral": "okun buba",
  "block.minecraft.fire_coral": "epo adan",
  "block.minecraft.horn_coral": "coral ti a mu",
  "block.minecraft.dead_brain_coral": "brakú ọpọlọ coral",
  "block.minecraft.dead_bubble_coral": "bkú bubble coral",
  "block.minecraft.dead_fire_coral": "coral fire coral",
  "block.minecraft.dead_horn_coral": "hornkú ikun coral",
  "block.minecraft.dead_tube_coral": "ralkú ikulu ikirun",
  "block.minecraft.tube_coral_fan": "a àìpẹ ti coral tubular",
  "block.minecraft.brain_coral_fan": "a fọọmu ti agbada epo",
  "block.minecraft.bubble_coral_fan": "a àìpẹ ti iyọ iṣuu",
  "block.minecraft.fire_coral_fan": "a fọọmu ti erun igbona",
  "block.minecraft.horn_coral_fan": "a àìpẹ ti adiye aman",
  "block.minecraft.dead_tube_coral_fan": "akan ti o ku ti adiye adiro",
  "block.minecraft.dead_brain_coral_fan": "òkú ọgbẹ àrùn",
  "block.minecraft.dead_bubble_coral_fan": "afẹfẹ ti o ku ti ẹja iṣan",
  "block.minecraft.dead_fire_coral_fan": "okun apanirun ti adun ti ina",
  "block.minecraft.dead_horn_coral_fan": "omi apanirun ti ọra amọ",
  "block.minecraft.blue_ice": "bulu yinyin",
  "block.minecraft.conduit": "the asiwaju",
  "block.minecraft.polished_granite_stairs": "awọn igunna polished granite",
  "block.minecraft.smooth_red_sandstone_stairs": "awọn irẹrin sandstone pẹtẹpẹtẹ",
  "block.minecraft.mossy_stone_brick_stairs": "mossy stone brick stairs",
  "block.minecraft.polished_diorite_stairs": "awọn diorite poli ti o ni ẹgẹ",
  "block.minecraft.mossy_cobblestone_stairs": "mossy cobblestone awọn atẹgun",
  "block.minecraft.end_stone_brick_stairs": "opin brick stone stone",
  "block.minecraft.stone_stairs": "okuta okuta",
  "block.minecraft.smooth_sandstone_stairs": "awọn igun gilaasi awọn irẹrin",
  "block.minecraft.smooth_quartz_stairs": "smooth quartz awọn atẹgun",
  "block.minecraft.granite_stairs": "granite awọn atẹgun",
  "block.minecraft.andesite_stairs": "awọn atẹgun andesite",
  "block.minecraft.red_nether_brick_stairs": "nether brick stairs",
  "block.minecraft.polished_andesite_stairs": "atẹgun andesite ti a da didan",
  "block.minecraft.diorite_stairs": "diorite pẹtẹẹsì",
  "block.minecraft.polished_granite_slab": "awọn ẹlẹdẹ granite slab",
  "block.minecraft.smooth_red_sandstone_slab": "awọn ọgbọn ikun iyanrin pupa",
  "block.minecraft.mossy_stone_brick_slab": "a apẹrẹ okuta biriki",
  "block.minecraft.polished_diorite_slab": "agbara diorite polished",
  "block.minecraft.mossy_cobblestone_slab": "mossy cobblestone slab",
  "block.minecraft.end_stone_brick_slab": "opin brick stone",
  "block.minecraft.smooth_sandstone_slab": "dudu gusu",
  "block.minecraft.smooth_quartz_slab": "smooth quartz slab",
  "block.minecraft.granite_slab": "granite slab",
  "block.minecraft.andesite_slab": "andesite slab",
  "block.minecraft.red_nether_brick_slab": "red nether brick slab",
  "block.minecraft.polished_andesite_slab": "agbara andesite ti a gbin",
  "block.minecraft.diorite_slab": "diorite slab",
  "block.minecraft.scaffolding": "scaffolding",
  "block.minecraft.iron_door": "iron enu",
  "block.minecraft.oak_door": "oaku enu",
  "block.minecraft.spruce_door": "spruce enu",
  "block.minecraft.birch_door": "birch enu",
  "block.minecraft.jungle_door": "jungle enu",
  "block.minecraft.acacia_door": "acacia enu",
  "block.minecraft.dark_oak_door": "oaku dudu enu",
  "block.minecraft.crimson_door": "crimson ilekun",
  "block.minecraft.warped_door": "ilekun warped",
  "block.minecraft.repeater": "atunṣe redstone",
  "block.minecraft.comparator": "afiwera redstone",
  "block.minecraft.structure_block": "dẹkun igbekale",
  "block.minecraft.jigsaw": "jigsaw àkọsílẹ",
  "item.minecraft.turtle_helmet": "ipele ijapa□□nigbati o ba wọ si ori:□+2 ihamọra",
  "item.minecraft.scute": "koju",
  "item.minecraft.iron_shovel": "isele irin□□nigbati ni akọkọ ọwọ:□+3.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.iron_pickaxe": "iron pickaxe□□nigbati ni akọkọ ọwọ:□+3 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.iron_axe": "axe iron□□nigbati ni akọkọ ọwọ:□+8 ipalara ikọlu□-3.1 iyara attack",
  "item.minecraft.flint_and_steel": "flint ati irin",
  "item.minecraft.apple": "apu",
  "item.minecraft.bow": "teriba",
  "item.minecraft.arrow": "ọfa",
  "item.minecraft.coal": "alóró",
  "item.minecraft.charcoal": "eedu",
  "item.minecraft.diamond": "alumọni",
  "item.minecraft.iron_ingot": "iron ingot",
  "item.minecraft.gold_ingot": "goolu ingot",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "alokuirin netherite",
  "item.minecraft.iron_sword": "idà iron□□nigbati ni akọkọ ọwọ:□+5 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.wooden_sword": "idà igi□□nigbati ni akọkọ ọwọ:□+3 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.wooden_shovel": "onigi shovel□□nigbati ni akọkọ ọwọ:□+1.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.wooden_pickaxe": "onigi pickaxe□□nigbati ni akọkọ ọwọ:□+1 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.wooden_axe": "axe onigi□□nigbati ni akọkọ ọwọ:□+6 ipalara ikọlu□-3.2 iyara attack",
  "item.minecraft.stone_sword": "idà stone□□nigbati ni akọkọ ọwọ:□+4 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.stone_shovel": "isele irin□□nigbati ni akọkọ ọwọ:□+2.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.stone_pickaxe": "onigi pickaxe□□nigbati ni akọkọ ọwọ:□+2 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.stone_axe": "apata okuta□□nigbati ni akọkọ ọwọ:□+8 ipalara ikọlu□-3.2 iyara attack",
  "item.minecraft.diamond_sword": "idẹ diamond□□nigbati ni akọkọ ọwọ:□+6 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.diamond_shovel": "iyanrin diamond□□nigbati ni akọkọ ọwọ:□+4.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.diamond_pickaxe": "apata diamondka□□nigbati ni akọkọ ọwọ:□+4 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.diamond_axe": "okuta ẹsọ́□□nigbati ni akọkọ ọwọ:□+8 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.stick": "lẹẹmọ",
  "item.minecraft.bowl": "abọ",
  "item.minecraft.mushroom_stew": "ipẹtẹ olu",
  "item.minecraft.golden_sword": "idà golden□□nigbati ni akọkọ ọwọ:□+3 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.golden_shovel": "ṣẹfulu ti wura□□nigbati ni akọkọ ọwọ:□+1.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.golden_pickaxe": "ẹwẹ pickaxe□□nigbati ni akọkọ ọwọ:□+1 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.golden_axe": "axórí. fin□□nigbati ni akọkọ ọwọ:□+6 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.netherite_sword": "idà netherite□□nigbati ni akọkọ ọwọ:□+7 ipalara ikọlu□-2.4 iyara attack",
  "item.minecraft.netherite_shovel": "ṣẹgun netherite□□nigbati ni akọkọ ọwọ:□+5.5 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.netherite_pickaxe": "pickaxe ti netherite□□nigbati ni akọkọ ọwọ:□+5 ipalara ikọlu□-2.8 iyara attack",
  "item.minecraft.netherite_axe": "ax ti netherite□□nigbati ni akọkọ ọwọ:□+9 ipalara ikọlu□-3 iyara attack",
  "item.minecraft.string": "okun",
  "item.minecraft.feather": "ẹyẹ",
  "item.minecraft.gunpowder": "epo ibon",
  "item.minecraft.wooden_hoe": "onigi hoe□□nigbati ni akọkọ ọwọ:□-3 iyara attack",
  "item.minecraft.stone_hoe": "hoe stone□□nigbati ni akọkọ ọwọ:□-2 iyara attack",
  "item.minecraft.iron_hoe": "irin iron□□nigbati ni akọkọ ọwọ:□-1 iyara attack",
  "item.minecraft.diamond_hoe": "hoe iyebiye□□nigbati ni akọkọ ọwọ:",
  "item.minecraft.golden_hoe": "hórégé□□nigbati ni akọkọ ọwọ:□-3 iyara attack",
  "item.minecraft.netherite_hoe": "hoe xite□□nigbati ni akọkọ ọwọ:",
  "item.minecraft.wheat_seeds": "irugbin alikama",
  "item.minecraft.wheat": "alikama",
  "item.minecraft.bread": "burẹdi",
  "item.minecraft.leather_helmet": "alawọ fila□□nigbati o ba wọ si ori:□+1 ihamọra",
  "item.minecraft.leather_chestplate": "alawọ tunic□□nigbati o ba wọ:□+3 ihamọra",
  "item.minecraft.leather_leggings": "awọn sokoto alawọ□□nigbati o ba fi si ẹsẹ rẹ:□+2 ihamọra",
  "item.minecraft.leather_boots": "alawọ orunkun□□nigbati o ba wa ni ẹsẹ rẹ:□+1 ihamọra",
  "item.minecraft.chainmail_helmet": "ipele ibori□□nigbati o ba wọ si ori:□+2 ihamọra",
  "item.minecraft.chainmail_chestplate": "ipa-ọṣọ□□nigbati o ba wọ:□+5 ihamọra",
  "item.minecraft.chainmail_leggings": "ohun elo gbigbe□□nigbati o ba fi si ẹsẹ rẹ:□+4 ihamọra",
  "item.minecraft.chainmail_boots": "bata pq□□nigbati o ba wa ni ẹsẹ rẹ:□+1 ihamọra",
  "item.minecraft.iron_helmet": "ibori irin□□nigbati o ba wọ si ori:□+2 ihamọra",
  "item.minecraft.iron_chestplate": "irin chestplate□□nigbati o ba wọ:□+6 ihamọra",
  "item.minecraft.iron_leggings": "irin leggings□□nigbati o ba fi si ẹsẹ rẹ:□+5 ihamọra",
  "item.minecraft.iron_boots": "irin boots□□nigbati o ba wa ni ẹsẹ rẹ:□+2 ihamọra",
  "item.minecraft.diamond_helmet": "ibori diamond□□nigbati o ba wọ si ori:□+3 ihamọra□+2 ihamọra ihamọra",
  "item.minecraft.diamond_chestplate": "okuta iyebiye□□nigbati o ba wọ:□+8 ihamọra□+2 ihamọra ihamọra",
  "item.minecraft.diamond_leggings": "awọn okuta iyebiye□□nigbati o ba fi si ẹsẹ rẹ:□+6 ihamọra□+2 ihamọra ihamọra",
  "item.minecraft.diamond_boots": "bata orunkun□□nigbati o ba wa ni ẹsẹ rẹ:□+3 ihamọra□+2 ihamọra ihamọra",
  "item.minecraft.golden_helmet": "àṣíborí oníwúrà□□nigbati o ba wọ si ori:□+2 ihamọra",
  "item.minecraft.golden_chestplate": "aṣayan ẹlẹsẹ wura□□nigbati o ba wọ:□+5 ihamọra",
  "item.minecraft.golden_leggings": "awọn leggings goolu□□nigbati o ba fi si ẹsẹ rẹ:□+3 ihamọra",
  "item.minecraft.golden_boots": "awọn bata goolu□□nigbati o ba wa ni ẹsẹ rẹ:□+1 ihamọra",
  "item.minecraft.netherite_helmet": "helmiteite□□nigbati o ba wọ si ori:□+3 ihamọra□+3 ihamọra ihamọra□+1 idawọle knockback",
  "item.minecraft.netherite_chestplate": "chestpiece netherite□□nigbati o ba wọ:□+8 ihamọra□+3 ihamọra ihamọra□+1 idawọle knockback",
  "item.minecraft.netherite_leggings": "leggings netherite□□nigbati o ba fi si ẹsẹ rẹ:□+6 ihamọra□+3 ihamọra ihamọra□+1 idawọle knockback",
  "item.minecraft.netherite_boots": "awọn bata netherite□□nigbati o ba wa ni ẹsẹ rẹ:□+3 ihamọra□+3 ihamọra ihamọra□+1 idawọle knockback",
  "item.minecraft.flint": "okuta",
  "item.minecraft.porkchop": "aise ẹlẹdẹ ẹlẹdẹ",
  "item.minecraft.cooked_porkchop": "jinna ẹlẹdẹ",
  "item.minecraft.painting": "kikun",
  "item.minecraft.golden_apple": "apple ti wura",
  "item.minecraft.enchanted_golden_apple": "eniti o ni apu goolu",
  "block.minecraft.oak_sign": "aami ọṣọ",
  "block.minecraft.spruce_sign": "egungun spruce",
  "block.minecraft.birch_sign": "birch awo",
  "block.minecraft.jungle_sign": "ipele igbo",
  "block.minecraft.acacia_sign": "akara awo",
  "block.minecraft.dark_oak_sign": "oaku wọle ojiji",
  "block.minecraft.crimson_sign": "crimson ami",
  "block.minecraft.warped_sign": "ami ami",
  "item.minecraft.bucket": "garawa",
  "item.minecraft.water_bucket": "garawa omi",
  "item.minecraft.lava_bucket": "lava garawa",
  "item.minecraft.minecart": "minecart",
  "item.minecraft.saddle": "gàárì",
  "item.minecraft.redstone": "redstone lulú",
  "item.minecraft.snowball": "bọọlu afẹsẹgba",
  "item.minecraft.oak_boat": "okọ oju omi oaku",
  "item.minecraft.leather": "awọ",
  "item.minecraft.milk_bucket": "wara garawa",
  "item.minecraft.pufferfish_bucket": "garawa pẹlu fifaju",
  "item.minecraft.salmon_bucket": "akara pẹlu iru ẹja nla kan",
  "item.minecraft.cod_bucket": "garawa pẹlu cod",
  "item.minecraft.tropical_fish_bucket": "ogo kan pẹlu ẹja ti oorun",
  "item.minecraft.brick": "okuta",
  "item.minecraft.clay_ball": "odidi amọ",
  "block.minecraft.dried_kelp_block": "ti gbin kelp block",
  "item.minecraft.paper": "iwe",
  "item.minecraft.book": "iwe",
  "item.minecraft.slime_ball": "slimeball",
  "item.minecraft.chest_minecart": "minecart pẹlu àya",
  "item.minecraft.furnace_minecart": "minecart pẹlu ileru",
  "item.minecraft.egg": "ẹyin",
  "item.minecraft.compass": "kọmpasi",
  "item.minecraft.fishing_rod": "igi ipẹja",
  "item.minecraft.clock": "aago",
  "item.minecraft.glowstone_dust": "ekuru glowstone",
  "item.minecraft.cod": "iwọn ipele",
  "item.minecraft.salmon": "salmoni aise",
  "item.minecraft.tropical_fish": "ipa ọna oorun eja",
  "item.minecraft.pufferfish": "pufferfish",
  "item.minecraft.cooked_cod": "ṣunna ẹja kan",
  "item.minecraft.cooked_salmon": "salmoni ti a jinna",
  "item.minecraft.ink_sac": "inki sac",
  "item.minecraft.red_dye": "red lulú",
  "item.minecraft.green_dye": "awo alawọ",
  "item.minecraft.cocoa_beans": "koko ewa",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "aro eleyi",
  "item.minecraft.cyan_dye": "awọ cyan",
  "item.minecraft.light_gray_dye": "ina grẹy",
  "item.minecraft.gray_dye": "grẹy dai",
  "item.minecraft.pink_dye": "pink dai",
  "item.minecraft.lime_dye": "orombo wewe",
  "item.minecraft.yellow_dye": "awọ ofeefee",
  "item.minecraft.light_blue_dye": "awọ bulu didan",
  "item.minecraft.magenta_dye": "magenta dai",
  "item.minecraft.orange_dye": "oyinbo osan",
  "item.minecraft.bone_meal": "ounjẹ egungun",
  "item.minecraft.blue_dye": "awọ bulu",
  "item.minecraft.brown_dye": "awọ dai",
  "item.minecraft.black_dye": "dudu dai",
  "item.minecraft.white_dye": "funfun dai",
  "item.minecraft.bone": "egungun",
  "item.minecraft.sugar": "suga",
  "block.minecraft.cake": "esufulawa",
  "block.minecraft.white_bed": "funfun ibusun",
  "block.minecraft.orange_bed": "osan ibusun",
  "block.minecraft.magenta_bed": "magenta ibusun",
  "block.minecraft.light_blue_bed": "ibusun bulu ti o ni ina",
  "block.minecraft.yellow_bed": "ibusun ofeefee",
  "block.minecraft.lime_bed": "orombo wewe",
  "block.minecraft.pink_bed": "pink ibusun",
  "block.minecraft.gray_bed": "grẹy ibusun",
  "block.minecraft.light_gray_bed": "ibusun grẹy",
  "block.minecraft.cyan_bed": "ibusun cyan",
  "block.minecraft.purple_bed": "ibusun eleyi ti",
  "block.minecraft.blue_bed": "bulu ibusun",
  "block.minecraft.brown_bed": "brown ibusun",
  "block.minecraft.green_bed": "alawọ ewe ibusun",
  "block.minecraft.red_bed": "pupa ibusun",
  "block.minecraft.black_bed": "ibusun dudu",
  "item.minecraft.cookie": "kuki",
  "item.minecraft.filled_map": "maapu□#0",
  "item.minecraft.shears": "shears",
  "item.minecraft.melon_slice": "a nkan ti elegede",
  "item.minecraft.dried_kelp": "omi omi ti o gbẹ",
  "item.minecraft.pumpkin_seeds": "awọn irugbin elegede",
  "item.minecraft.melon_seeds": "awọn irugbin melon",
  "item.minecraft.beef": "aise eran malu",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "adie aise",
  "item.minecraft.cooked_chicken": "adie jinna",
  "item.minecraft.rotten_flesh": "eran run",
  "item.minecraft.ender_pearl": "ender parili",
  "item.minecraft.blaze_rod": "blaze ọpá",
  "item.minecraft.ghast_tear": "ghast omije",
  "item.minecraft.gold_nugget": "ohun elo goolu",
  "item.minecraft.nether_wart": "nether wart",
  "item.minecraft.potion": "ikoko ti ko ṣee gbe□ko si awọn ipa",
  "item.minecraft.glass_bottle": "igo gilasi",
  "item.minecraft.spider_eye": "oju alantakun",
  "item.minecraft.fermented_spider_eye": "fermented oju alantaku",
  "item.minecraft.blaze_powder": "blaze lulú",
  "item.minecraft.magma_cream": "ipara magma",
  "block.minecraft.brewing_stand": "tun",
  "block.minecraft.cauldron": "cauldron",
  "item.minecraft.ender_eye": "oju ti ender",
  "item.minecraft.glistering_melon_slice": "giṣẹ melon ibẹbẹ",
  "item.minecraft.bat_spawn_egg": "ẹyin pe pipe",
  "item.minecraft.bee_spawn_egg": "ẹyin bee spawn",
  "item.minecraft.blaze_spawn_egg": "ẹyin pe kan ina",
  "item.minecraft.cat_spawn_egg": "ṣẹda o nran kan",
  "item.minecraft.cave_spider_spawn_egg": "ẹyin pipe ni agbọn egungun kan",
  "item.minecraft.chicken_spawn_egg": "ẹyin pipe kan gboo",
  "item.minecraft.cod_spawn_egg": "ẹyin pipe fun cod",
  "item.minecraft.cow_spawn_egg": "ẹyin pipe kan maalu",
  "item.minecraft.creeper_spawn_egg": "ẹyin pipe creeper",
  "item.minecraft.dolphin_spawn_egg": "ẹyin pe ẹja kan",
  "item.minecraft.donkey_spawn_egg": "ẹyin pe ọmọ kẹtẹkẹtẹ kan",
  "item.minecraft.drowned_spawn_egg": "ẹyin pe olutọru",
  "item.minecraft.elder_guardian_spawn_egg": "ẹyin pe aṣoju alagba",
  "item.minecraft.enderman_spawn_egg": "ẹyin pe enderman",
  "item.minecraft.endermite_spawn_egg": "ẹyin pe endermite",
  "item.minecraft.evoker_spawn_egg": "ẹyin ti o pe olupe naa",
  "item.minecraft.fox_spawn_egg": "fox ṣiṣe",
  "item.minecraft.ghast_spawn_egg": "ẹyin pe ghast",
  "item.minecraft.guardian_spawn_egg": "ẹyin pe olutọju",
  "item.minecraft.hoglin_spawn_egg": "ẹyin hoglin summon",
  "item.minecraft.horse_spawn_egg": "ẹyin pe ẹṣin",
  "item.minecraft.husk_spawn_egg": "ẹyin pipe fun ogbele",
  "item.minecraft.llama_spawn_egg": "ẹyin pe laini",
  "item.minecraft.magma_cube_spawn_egg": "ẹyin ti n pe kọnisi magma",
  "item.minecraft.mooshroom_spawn_egg": "ẹyin pe eran maalu kan",
  "item.minecraft.mule_spawn_egg": "ẹyin pe ikun kan",
  "item.minecraft.ocelot_spawn_egg": "ẹyin pe ocelot",
  "item.minecraft.panda_spawn_egg": "ṣiṣẹda panda",
  "item.minecraft.parrot_spawn_egg": "ẹyin pe ikẹjọ kan",
  "item.minecraft.phantom_spawn_egg": "ẹyin pe pipe kan",
  "item.minecraft.pig_spawn_egg": "ẹyin pipe kan ẹlẹdẹ",
  "item.minecraft.piglin_spawn_egg": "ẹjẹ piglin summon",
  "item.minecraft.pillager_spawn_egg": "ṣiṣe buburu",
  "item.minecraft.polar_bear_spawn_egg": "ẹyin ti o pe ni agbọn pola kan",
  "item.minecraft.pufferfish_spawn_egg": "ẹyin pe pipe kan",
  "item.minecraft.rabbit_spawn_egg": "ẹyin pe ehoro",
  "item.minecraft.ravager_spawn_egg": "ṣẹda akọmalu",
  "item.minecraft.salmon_spawn_egg": "ẹyin pipe fun iru ẹja nla kan",
  "item.minecraft.sheep_spawn_egg": "ẹyin pe agutan",
  "item.minecraft.shulker_spawn_egg": "ẹyin pe shulker",
  "item.minecraft.silverfish_spawn_egg": "ẹyin pe ẹja iha",
  "item.minecraft.skeleton_spawn_egg": "ẹyin ti n pe egungun",
  "item.minecraft.skeleton_horse_spawn_egg": "ẹyin pe ọmọ ẹṣin egungun kan",
  "item.minecraft.slime_spawn_egg": "ẹyin pe slime",
  "item.minecraft.spider_spawn_egg": "ẹyin pipe kan spider",
  "item.minecraft.squid_spawn_egg": "ẹyin pe pipe kan",
  "item.minecraft.stray_spawn_egg": "ẹyin ti o pe ni aṣiṣe naa",
  "item.minecraft.strider_spawn_egg": "onje itaja summon egg",
  "item.minecraft.trader_llama_spawn_egg": "ṣẹda onisowo oniṣowo kan",
  "item.minecraft.tropical_fish_spawn_egg": "ẹyin pe pipe eja ti nwaye",
  "item.minecraft.turtle_spawn_egg": "ẹyin pe ikoko kan",
  "item.minecraft.vex_spawn_egg": "ẹyin pe ikorira",
  "item.minecraft.villager_spawn_egg": "ẹyin pe olutọju naa",
  "item.minecraft.vindicator_spawn_egg": "ẹyin pe pipe kan",
  "item.minecraft.wandering_trader_spawn_egg": "ṣẹda onikan iṣowo",
  "item.minecraft.witch_spawn_egg": "ẹyin pe ọrẹ kan",
  "item.minecraft.wither_skeleton_spawn_egg": "ẹyin ti n pe wither egungun",
  "item.minecraft.wolf_spawn_egg": "ẹyin pe ikoko kan",
  "item.minecraft.zoglin_spawn_egg": "zoglin summon igba",
  "item.minecraft.zombie_spawn_egg": "ẹyin pe zombie",
  "item.minecraft.zombie_horse_spawn_egg": "ẹyin pe zombie ẹṣin",
  "item.minecraft.zombie_villager_spawn_egg": "ẹyin pe olutọju zombie naa",
  "item.minecraft.zombified_piglin_spawn_egg": "zombie piglin summon igba",
  "item.minecraft.experience_bottle": "igo o' enchanting",
  "item.minecraft.fire_charge": "ina idiyele",
  "item.minecraft.writable_book": "iwe ati ki o quill",
  "item.minecraft.written_book": "iwe ti a kọ",
  "item.minecraft.emerald": "emerald",
  "item.minecraft.item_frame": "fireemu ohunkan",
  "block.minecraft.flower_pot": "ikoko adodo",
  "item.minecraft.carrot": "karọọti",
  "item.minecraft.potato": "ọdunkun",
  "item.minecraft.baked_potato": "ndin ọdunkun",
  "item.minecraft.poisonous_potato": "majele ti ọdunkun",
  "item.minecraft.map": "sofo maapu",
  "item.minecraft.golden_carrot": "karooti goolu",
  "block.minecraft.skeleton_skull": "agbon timole",
  "block.minecraft.wither_skeleton_skull": "wither egungun timole",
  "block.minecraft.player_head": "olusakoso akọ",
  "block.minecraft.zombie_head": "zombie ori",
  "block.minecraft.creeper_head": "creeper orí",
  "block.minecraft.dragon_head": "dragoni orí",
  "item.minecraft.carrot_on_a_stick": "karooti lori ọpá kan",
  "item.minecraft.warped_fungus_on_a_stick": "ipeja olu olu ipeja",
  "item.minecraft.nether_star": "nether irawọ",
  "item.minecraft.pumpkin_pie": "elegede paii",
  "item.minecraft.firework_rocket": "ise ina rocket",
  "item.minecraft.firework_star": "ise ina irawo",
  "item.minecraft.enchanted_book": "iwe enchanted",
  "item.minecraft.nether_brick": "nether brick",
  "item.minecraft.quartz": "nether quartz",
  "item.minecraft.tnt_minecart": "minecart pẹlu tnt",
  "item.minecraft.hopper_minecart": "minecart pẹlu hopper",
  "item.minecraft.prismarine_shard": "prismarine shard",
  "item.minecraft.prismarine_crystals": "awọn kirisita prismarine",
  "item.minecraft.rabbit": "ehoro aise",
  "item.minecraft.cooked_rabbit": "ehoro jinna",
  "item.minecraft.rabbit_stew": "ehoro ipẹtẹ",
  "item.minecraft.rabbit_foot": "ẹsẹ ehoro",
  "item.minecraft.rabbit_hide": "ìbòmọlẹ ehoro",
  "item.minecraft.armor_stand": "ihamọra imurasilẹ",
  "item.minecraft.iron_horse_armor": "ihamọra ẹṣin irin",
  "item.minecraft.golden_horse_armor": "golden ẹṣin ihamọra",
  "item.minecraft.diamond_horse_armor": "ihamọra ẹṣin iyebiye",
  "item.minecraft.leather_horse_armor": "ologun ẹṣin ẹṣin",
  "item.minecraft.lead": "asiwaju",
  "item.minecraft.name_tag": "orukọ tag",
  "item.minecraft.command_block_minecart": "minecart pẹlu àṣẹ àkọsílẹ",
  "item.minecraft.mutton": "aise odidi",
  "item.minecraft.cooked_mutton": "mutton jinna",
  "block.minecraft.white_banner": "banner funfun",
  "block.minecraft.orange_banner": "asia asia",
  "block.minecraft.magenta_banner": "asia banner",
  "block.minecraft.light_blue_banner": "imọlẹ blue banner",
  "block.minecraft.yellow_banner": "asia yellow",
  "block.minecraft.lime_banner": "asia orombo",
  "block.minecraft.pink_banner": "asia pink",
  "block.minecraft.gray_banner": "banki grey",
  "block.minecraft.light_gray_banner": "imọlẹ grey light",
  "block.minecraft.cyan_banner": "banki cyan",
  "block.minecraft.purple_banner": "asia asia",
  "block.minecraft.blue_banner": "asia blue",
  "block.minecraft.brown_banner": "brown banner",
  "block.minecraft.green_banner": "banner green",
  "block.minecraft.red_banner": "asia pupa",
  "block.minecraft.black_banner": "asia dudu",
  "item.minecraft.end_crystal": "end gara",
  "item.minecraft.chorus_fruit": "chorus eso",
  "item.minecraft.popped_chorus_fruit": "ti jade chorus eso",
  "item.minecraft.beetroot": "beetroot",
  "item.minecraft.beetroot_seeds": "beetroot irugbin",
  "item.minecraft.beetroot_soup": "bimo beetroot",
  "item.minecraft.dragon_breath": "ìmí ti dragon",
  "item.minecraft.splash_potion": "asesejade uncraftable iwon□ko si awọn ipa",
  "item.minecraft.spectral_arrow": "apoti oju",
  "item.minecraft.tipped_arrow": "ọfa ti a ko le gbe jade□ko si awọn ipa",
  "item.minecraft.lingering_potion": "lingering uncraftable iwon□ko si awọn ipa",
  "item.minecraft.shield": "apata",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "okọ oju omi spruce",
  "item.minecraft.birch_boat": "oko birch",
  "item.minecraft.jungle_boat": "okọ oju omi igbo",
  "item.minecraft.acacia_boat": "okọ akasia",
  "item.minecraft.dark_oak_boat": "okọ oju omi oaku dudu",
  "item.minecraft.totem_of_undying": "totem ti iku",
  "item.minecraft.shulker_shell": "ikarahun shulker",
  "item.minecraft.iron_nugget": "irin nugget",
  "item.minecraft.knowledge_book": "iwe imọ",
  "item.minecraft.debug_stick": "ọpa alaburo",
  "item.minecraft.music_disc_13": "disiki orin□c418 - 13",
  "item.minecraft.music_disc_cat": "disiki orin□c418 - cat",
  "item.minecraft.music_disc_blocks": "disiki orin□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disiki orin□c418 - chirp",
  "item.minecraft.music_disc_far": "disiki orin□c418 - far",
  "item.minecraft.music_disc_mall": "disiki orin□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disiki orin□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disiki orin□c418 - stal",
  "item.minecraft.music_disc_strad": "disiki orin□c418 - strad",
  "item.minecraft.music_disc_ward": "disiki orin□c418 - ward",
  "item.minecraft.music_disc_11": "disiki orin□c418 - 11",
  "item.minecraft.music_disc_wait": "disiki orin□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disiki orin□lina rein- pigstep",
  "item.minecraft.trident": "trident□□nigbati ni akọkọ ọwọ:□+8 ipalara ikọlu□-2.9 iyara attack",
  "item.minecraft.phantom_membrane": "awọ-ara koriko",
  "item.minecraft.nautilus_shell": "ikarahun ti a nautilus",
  "item.minecraft.heart_of_the_sea": "okan ti okun",
  "item.minecraft.crossbow": "crossbow",
  "item.minecraft.suspicious_stew": "ipanu ifura",
  "block.minecraft.loom": "loom",
  "item.minecraft.flower_banner_pattern": "apẹẹrẹ asia□gbigba ododo",
  "item.minecraft.creeper_banner_pattern": "apẹrẹ apẹrẹ□gbigba agbara creeper",
  "item.minecraft.skull_banner_pattern": "apẹẹrẹ asia□agbari owo-ori",
  "item.minecraft.mojang_banner_pattern": "apẹẹrẹ asia□ohun",
  "item.minecraft.globe_banner_pattern": "apẹẹrẹ asia□agbaiye",
  "item.minecraft.piglin_banner_pattern": "apẹrẹ apẹrẹ□imu",
  "block.minecraft.composter": "composter",
  "block.minecraft.barrel": "aṣayan ti a ko mọ",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "blast furnace",
  "block.minecraft.cartography_table": "atilẹyin awọn aworan",
  "block.minecraft.fletching_table": "fletching table",
  "block.minecraft.grindstone": "oṣuwọn eefun",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "titiipa smithing",
  "block.minecraft.stonecutter": "ṣiṣẹ stone",
  "block.minecraft.bell": "belii",
  "block.minecraft.lantern": "atupa",
  "block.minecraft.soul_lantern": "okun okun",
  "item.minecraft.sweet_berries": "sweet eso",
  "block.minecraft.campfire": "agbona mejo",
  "block.minecraft.soul_campfire": "nipa ina ti ẹmi",
  "block.minecraft.shroomlight": "itankalẹ yara",
  "item.minecraft.honeycomb": "oyin oyin",
  "block.minecraft.bee_nest": "bee itẹ-ẹiyẹ",
  "block.minecraft.beehive": "bee",
  "item.minecraft.honey_bottle": "igo ipara",
  "block.minecraft.honey_block": "dẹkun ẹnu",
  "block.minecraft.honeycomb_block": "dina ohun amorindun",
  "block.minecraft.lodestone": "oofa",
  "block.minecraft.netherite_block": "dẹkun netherite",
  "block.minecraft.ancient_debris": "ibajẹ atijọ",
  "block.minecraft.target": "ibi-afẹde",
  "block.minecraft.crying_obsidian": "wiko obsidian",
  "block.minecraft.blackstone": "okuta dudu",
  "block.minecraft.blackstone_slab": "apẹrẹ gusu",
  "block.minecraft.blackstone_stairs": "ile ogiri dudu",
  "block.minecraft.gilded_blackstone": "okuta dudu dudu",
  "block.minecraft.polished_blackstone": "okuta dudu ti a ni didan",
  "block.minecraft.polished_blackstone_slab": "didan stone stone",
  "block.minecraft.polished_blackstone_stairs": "odi okuta okuta didan dudu",
  "block.minecraft.chiseled_polished_blackstone": "okuta didan ti dudu didan",
  "block.minecraft.polished_blackstone_bricks": "awọn okuta biriki didan didan",
  "block.minecraft.polished_blackstone_brick_slab": "okuta dudu biriki slab",
  "block.minecraft.polished_blackstone_brick_stairs": "dudu okuta didan biriki",
  "block.minecraft.cracked_polished_blackstone_bricks": "biriki okuta didan dudu pẹlu awọn dojuijako",
  "block.minecraft.respawn_anchor": "olupin respawn",
}
export const yo_ng = items; 
